import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'money'})
export class MoneyPipe implements PipeTransform {
  public transform(amount: number): any {
    if (amount == null) {
      return null;
    }

    return this.numberFormat(amount / 100, ',', ' ') + '€';
  }

  private numberFormat(num: number, decimalSeparator: string, thousandSeparator: string): string {
    if (!isFinite(num)) {
      return num.toString();
    }

    let a = num.toFixed(2).split('.');

    a[0] = a[0]
        .split('').reverse().join('')
        .replace(/\d{3}(?=\d)/g, '$&' + thousandSeparator)
        .split('').reverse().join('');

    return a.join(decimalSeparator);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/pipe/money.pipe.ts